import useResize from "./useResize";

export default useResize;
